export default {
    path: 'contract',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/contract/ContractList'),
    meta: {title:'绑定合同',cate:'个人中心'},
    children: [
        {
          path: 'create',
          component: () => import(/* webpackChunkName: "category-list" */ '@/pages/contract/CreateEdit'),
          meta: {title:'合同导入'},
        }
      ]
}